import {
  PropertyFragmentFragment,
  PropertyValueFragmentFragment,
} from "src/graphql/anti-fraud/__generated__/graphql";
import {
  mapBusinessTypeToAppDataType,
  mapDataTypeToAppDataType,
  parseTypedValue,
} from "src/mappers/typedValue.mappers";
import { Constraint, Property, PropertyValue } from "src/types/property";

export const mapToConstraint = (
  constraint: PropertyValueFragmentFragment["property"]["constraints"][number]
): Constraint => ({
  code: constraint.code,
  dataType: constraint.dataType ? mapDataTypeToAppDataType(constraint.dataType) : "string",
  description: constraint.description,
  message: constraint.message,
  value: constraint.value,
});

export const mapToProperty = (fragment: PropertyFragmentFragment): Property => ({
  code: fragment.code,
  name: fragment.name,
  dataType: mapBusinessTypeToAppDataType(fragment.businessType),
  mandatory: fragment.mandatory,
  constraints: fragment.constraints.map(mapToConstraint),
});

export const mapToPropertyValue = (fragment: PropertyValueFragmentFragment): PropertyValue => ({
  value: parseTypedValue(
    fragment.value,
    mapBusinessTypeToAppDataType(fragment.property.businessType)
  ),
  property: mapToProperty(fragment.property),
});
